import React from 'react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-background py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl font-semibold text-stone-900 mb-2">Refund & Return Policy</h1>
        <p className="text-muted-foreground mb-8 text-sm italic">Effective Date: 01-Mar-2026</p>
        
        <div className="prose prose-stone max-w-none space-y-8">
          <p className="text-stone-700 leading-relaxed">
            At SriSuktam Organics, we are committed to delivering premium quality rice, pulses, coldpressed oils, and other food products. 
            If you are not satisfied with your purchase, please review our policy below.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">1. Eligibility for Returns & Refunds</h2>
            <p className="text-stone-600 mb-2">We offer replacement or refund under the following conditions:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Product received is damaged or leaking</li>
              <li>Incorrect product delivered</li>
              <li>Product expired at the time of delivery</li>
              <li>Manufacturing defect</li>
            </ul>
            <p className="text-stone-800 font-medium mt-4 italic">To be eligible, customers must notify us within 48 hours of delivery.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">2. Non-Returnable Items</h2>
            <p className="text-stone-600 mb-2">Due to the perishable nature of food products, we cannot accept returns or issue refunds if:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>The product has been opened or used</li>
              <li>The complaint is raised after 48 hours of delivery</li>
              <li>Damage occurred due to improper storage</li>
              <li>Change of mind after purchase</li>
              <li>Minor packaging dents that do not affect product quality</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">3. How to Request a Refund</h2>
            <div className="bg-muted p-6 rounded-2xl border border-stone-200">
              <p className="text-stone-800 font-medium mb-4">To initiate a refund or replacement:</p>
              <ol className="list-decimal pl-5 text-stone-600 space-y-2">
                <li>Email us at <a href="mailto:srisuktamorganics@gmail.com" className="text-primary hover:underline">srisuktamorganics@gmail.com</a></li>
                <li>Provide your order number</li>
                <li>Attach clear photos of the product and packaging</li>
                <li>Briefly describe the issue</li>
              </ol>
              <p className="text-stone-600 mt-4 text-sm">Our support team will review your request within 2–3 business days.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">4. Refund Timeline</h2>
            <p className="text-stone-600 mb-2">If approved:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>Refunds will be processed to the original payment method</li>
              <li>Processing time: 5–7 business days</li>
              <li>Bank processing times may vary</li>
            </ul>
            <p className="text-stone-600 mt-2">For Cash on Delivery (COD) orders, refunds will be processed via bank transfer or UPI after verification.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">5. Replacement Policy</h2>
            <p className="text-stone-600 mb-2">If replacement is approved:</p>
            <ul className="list-disc pl-5 text-stone-600 space-y-1">
              <li>A new product will be dispatched at no additional cost</li>
              <li>Delivery timelines depend on location</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-4">6. Cancellation Policy</h2>
            <p className="text-stone-600">
              Orders can be cancelled only before dispatch. Once shipped, cancellation requests will not be accepted.
            </p>
          </section>

          <section className="bg-primary/5 p-6 rounded-2xl border border-primary/10">
            <h2 className="text-xl font-semibold text-stone-900 mb-4">7. Contact Us</h2>
            <p className="text-stone-700 mb-4">For any questions regarding returns or refunds:</p>
            <div className="space-y-2">
              <p className="font-semibold text-primary">SriSuktam Organics</p>
              <p className="text-stone-600">Email: <a href="mailto:srisuktamorganics@gmail.com" className="hover:underline">srisuktamorganics@gmail.com</a></p>
              <p className="text-stone-600">Phone: <a href="tel:+916360657668" className="hover:underline">+91-6360657668</a></p>
              <p className="text-stone-600 text-sm italic mt-2">Working Hours: Monday – Saturday, 9:30 AM – 6:30 PM</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
